var map = {
	"./1-heros.png": 8259,
	"./2-beach-volleyball.png": 8137,
	"./3-football.png": 3871,
	"./bike.png": 4919,
	"./l-football.png": 4038,
	"./l-running.png": 620,
	"./l-tennis.png": 3688,
	"./padel.png": 3638,
	"./tennis.png": 9449
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9755;